import { FEATURE_FLAGS } from '@/enums/FeatureFlags';
import { getStatsigClient } from '@/utils/statsig-client';

/**
 * Checks if a feature flag is enabled for the current user.
 *
 * @param key - The feature flag identifier to check
 * @returns `true` if the feature flag is enabled, `false` otherwise. Returns `false` if the Statsig client is not available.
 */
export const isFFEnabled = (key: FEATURE_FLAGS): boolean => {
  const client = getStatsigClient();
  return client?.checkGate(key) || false;
};
